import { useEffect, useState } from 'react';

const LONG_WAIT_THRESHOLD_MS = 30_000;
const LONG_WAIT_MESSAGE =
  'Response is taking longer than usual. Please wait...';

/**
 * Returns a warning message after {@link LONG_WAIT_THRESHOLD_MS} of continuous
 * activity, and clears it whenever `isActive` becomes false.
 *
 * @param isActive - Whether a search is currently in progress.
 */
export default function useLongWaitTimer(isActive: boolean): string | null {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    setMessage(null);
    if (!isActive) return undefined;
    const timer = setTimeout(
      () => setMessage(LONG_WAIT_MESSAGE),
      LONG_WAIT_THRESHOLD_MS
    );
    return () => clearTimeout(timer);
  }, [isActive]);

  return message;
}
